import { environment } from 'src/environments/environment';

import { ProtectedConfig } from '../models';

export class ProtectedConfigLoader {
  public static load(): Promise<ProtectedConfig> {
    return fetch(`/app/@config/config.protected.json?v=${environment.version}`).then((r) => r.json());
  }
}
